// Constellation
import { ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';

// Components
import FilterWrapper from '../FilterWrapper';

// Flux
import { useAppSelector } from '../../flux/configureStore';

// Misc / Utils
import { useOptimisticState } from '../../utils/hooks';

// Types
import type { PartialFilterType } from '../../models/Types';

const Distance = ({ onFilterChange }: { onFilterChange: (arg0: PartialFilterType) => void }) => {
  const distanceFilterRedux = useAppSelector((state) => state.filter.distanceInMiles);
  const [distanceFilter, setDistanceFilter] = useOptimisticState(distanceFilterRedux);
  const distanceStr = distanceFilter ? distanceFilter.toString() : '';

  const handleFilterClick = (_distance: string | Array<string>) => {
    // ToggleButtonGroup only returns string values
    const distance = Array.isArray(_distance) ? Number(_distance[0]) : Number(_distance);

    // cannot deselect current selection
    if (distance == distanceFilter) {
      return false;
    }

    setDistanceFilter(distance || null);
    onFilterChange({ distanceInMiles: distance || null });
  };

  // ToggleButtonGroup only accepts string values
  const component = (
    <ToggleButtonGroup
      defaultValue={distanceStr}
      onValueChange={handleFilterClick}
      aria-label="Distance filter"
      css={{ marginTop: '200', lgDown: { marginLeft: '600', marginBottom: '600' } }}
    >
      <ToggleButton value="">Any</ToggleButton>
      <ToggleButton value="1">1</ToggleButton>
      <ToggleButton value="2">2</ToggleButton>
      <ToggleButton value="3">3</ToggleButton>
      <ToggleButton value="4">4</ToggleButton>
      <ToggleButton value="5">5</ToggleButton>
    </ToggleButtonGroup>
  );

  return FilterWrapper({
    heading: 'Distance from your home (in miles)',
    children: component,
  });
};

export default Distance;
